<section>
  <form [formGroup]="form">
    <h1>Não possui nosso produto?</h1>  
    <span>"Click <a>aqui</a> e adquira agora!"</span>
    <label for="foo">
      <input id="foo" type="checkbox" formControlName="chkNotShowAgain" />Não mostrar novamente
    </label>
    <button (click)="close()">OK</button>
  </form>
</section>
